import { defineNuxtPlugin } from '#app'

/* 使用SSR服务端渲染时，Element Plus需要下面的特殊处理 */
/*   参考：https://cloud.tencent.com/developer/article/2203844 */
import { ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from 'element-plus'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(ID_INJECTION_KEY, {
    prefix: Math.floor(Math.random() * 10000),
    current: 0,
  })
  nuxtApp.vueApp.provide(ZINDEX_INJECTION_KEY, { current: 0 })
})

